import { Box, styled } from '@msdk/ui'
import {
  CE_Icon,
  Instructions_Icon,
  ManufacturerIcon,
  ManufacturerOutlinedIcon,
  MD_Icon,
  PrescriptionOnly,
  ReadInstructions_Icon,
  SerialNumber,
  UDI_Icon,
} from 'components/Icons/AboutIcons'
import { ImporterIcon } from 'components/Icons/AboutIcons/ImporterIcon'
import { ReactElement } from 'react'

const StyledIconContainerBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
`

type IconType =
  | 'CE'
  | 'ManufacturerOutlined'
  | 'Instructions'
  | 'UDI'
  | 'Manufacturer'
  | 'MD'
  | 'ReadInstructions'
  | 'PrescriptionOnly'
  | 'SerialNumber'
  | 'Importer'
  | 'Spacer'

export const AboutIconRenderer = ({ iconType }: { iconType: IconType }) => {
  const icons: Record<IconType, ReactElement> = {
    CE: <CE_Icon />,
    ManufacturerOutlined: <ManufacturerOutlinedIcon />,
    Instructions: <Instructions_Icon />,
    UDI: <UDI_Icon />,
    Manufacturer: <ManufacturerIcon />,
    MD: <MD_Icon />,
    ReadInstructions: <ReadInstructions_Icon />,
    PrescriptionOnly: <PrescriptionOnly />,
    SerialNumber: <SerialNumber />,
    Importer: <ImporterIcon />,
    Spacer: <Box width="48px" height="48px" />, // Placeholder for spacing
  }

  return <StyledIconContainerBox>{icons[iconType] || null}</StyledIconContainerBox>
}
